import CountAmenityHandler
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/components/CountAmenityHandler";
import NoAmenityForDirectionNotification
    from "@CheckOrder/features/amenities/components/NoAmenityForDirectionNotification";
import {
    PairedSingleAndReturnAmenitiesType
} from "@CheckOrder/features/amenities/types/PairedSingleAndReturnAmenities.type";
import useGetAmenitiesByDirection
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/hooks/useGetAmenitiesByDirection";
import {
    CountAmenitySelectedType
} from "@CheckOrder/features/amenities/features/countAmenity/types/CountAmenitySelected.type";
import {SetStateType} from "@/types/generic/SetState.type";
import NoAmenitiesAvailableInThisDirectionNotification
    from "@CheckOrder/features/amenities/features/countAmenity/features/list/components/NoAmenitiesAvailableInThisDirectionNotification";

interface CountAmenityListProps {
    selectedTab: "single" | "return"
    pairedAmenityGroups: PairedSingleAndReturnAmenitiesType,
    singleSelectedAmenities: Record<string, CountAmenitySelectedType>
    setSingleSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
    returnSelectedAmenities: Record<string, CountAmenitySelectedType>
    setReturnSelectedAmenities: SetStateType<Record<string, CountAmenitySelectedType>>
}

function CountAmenityList(props: CountAmenityListProps) {
    const {
        selectedTab,
        pairedAmenityGroups,
        singleSelectedAmenities,
        setSingleSelectedAmenities,
        returnSelectedAmenities,
        setReturnSelectedAmenities,
    } = props

    const {
        getAmenitiesByDirection,
        hasAmenitiesInThisDirection,
    } = useGetAmenitiesByDirection(pairedAmenityGroups, selectedTab)

    if (!hasAmenitiesInThisDirection) {
        return (
            <NoAmenitiesAvailableInThisDirectionNotification
                amenityGroupInDifferentDirection={selectedTab === "single" ? pairedAmenityGroups.returnGroup : pairedAmenityGroups.singleGroup}
                selectedTab={selectedTab}
            />
        )
    }

    return (
        <div className="ticket-amenities__amenity-selector">
            {pairedAmenityGroups.amenityKeys.map((amenityKey) => {
                const {
                    amenity,
                    amenityInDifferentDirection,
                } = getAmenitiesByDirection(amenityKey)

                if (!amenity) {
                    return (
                        <NoAmenityForDirectionNotification
                            key={`${amenityKey}-${selectedTab}`}
                            amenityInOtherDirection={amenityInDifferentDirection}
                        />
                    )
                }

                return (
                    <CountAmenityHandler
                        countAmenity={amenity}
                        key={`${amenityKey}-${selectedTab}`}
                        selectedAmenities={selectedTab === "single" ? singleSelectedAmenities : returnSelectedAmenities}
                        setSelectedAmenities={selectedTab === "single" ? setSingleSelectedAmenities : setReturnSelectedAmenities}
                    />
                )
            })}
        </div>
    )
}

export default CountAmenityList